import React from 'react';
import './GalleryVideosPage.css';

const sourceLinks = [
  'https://youtu.be/HT5tEaE04bI?si=XfhjiHBW13AQccKS',
  'https://youtu.be/cR-LStj8LTw?si=8QIqBhdcxV-V_7lq',
  'https://youtube.com/shorts/F3oq0SUHKos?si=sdXTczHRZWvabRWO',
  'https://youtube.com/shorts/dubu872_Zlw?si=2gvQdxbO7m2Y2LzS',
  'https://youtube.com/shorts/flFVtd9FfWI?si=HIVUnEG9TU2WM1Wb',
  'https://youtube.com/shorts/K5P038TzvCU?si=ngoHg3-G_awg85ke',
  'https://youtu.be/dubu872_Zlw?si=utCFkpSlramIlOT2',
  // 'https://www.facebook.com/share/r/17sFyDEjiy/',
  'https://youtu.be/9MHegjSf_W4?si=_-4Wv9ozseVuyIcX',
  'https://youtube.com/shorts/ShwfHv8k9iQ?si=oeCfGqgH_ZVMC95q',
  // 'https://www.facebook.com/share/v/1DNHuC3Qe8/',
  'https://youtube.com/shorts/PkARjlrz5p8?si=U5ObAUDlI-GLObFG',
  'https://youtube.com/shorts/zpYcAaWX1Vs?si=sz78sIRDnDWjjeLf',
  'https://youtube.com/shorts/lOIh2GdODxQ?si=WjG_AYG3U8yVL6SV',
  'https://youtube.com/shorts/9MHegjSf_W4?si=k6MHR_hAhx0M7tQ7',
];

function getYouTubeId(url) {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      return parsed.pathname.split('/').filter(Boolean)[0] || null;
    }

    if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (parsed.pathname.startsWith('/shorts/')) {
        return parsed.pathname.split('/')[2] || null;
      }

      if (parsed.pathname === '/watch') {
        return parsed.searchParams.get('v');
      }

      if (parsed.pathname.startsWith('/embed/')) {
        return parsed.pathname.split('/')[2] || null;
      }
    }
  } catch (error) {
    return null;
  }

  return null;
}

function mapToEmbed(link, index) {
  const ytId = getYouTubeId(link);

  if (ytId) {
    return {
      key: `yt:${ytId}`,
      title: `YouTube Video ${index + 1}`,
      provider: 'youtube',
      embedUrl: `https://www.youtube.com/embed/${ytId}`,
    };
  }

  if (link.includes('facebook.com')) {
    return {
      key: `fb:${link.split('?')[0].replace(/\/$/, '')}`,
      title: `Facebook Video ${index + 1}`,
      provider: 'facebook',
      sourceUrl: link,
    };
  }

  return null;
}

const videos = sourceLinks
  .map((link, index) => mapToEmbed(link, index))
  .filter(Boolean)
  .filter((video, index, arr) => arr.findIndex((item) => item.key === video.key) === index);

export default function GalleryVideosPage() {
  return (
    <section className="gallery-videos-page">
      <div className="gallery-videos-page__container">
        <h1 className="gallery-videos-page__title">Videos</h1>

        <div className="gallery-videos-grid">
          {videos.map((video) => (
            <article
              key={video.key}
              className={`gallery-video-card${video.provider === 'facebook' ? ' gallery-video-card--facebook' : ''}`}
            >
              {video.provider === 'facebook' ? (
                <div className="gallery-video-card__facebook-placeholder">
                  <h3>{video.title}</h3>
                  <p>Facebook privacy settings block inline embed for some shared videos.</p>
                  <a href={video.sourceUrl} target="_blank" rel="noreferrer" className="gallery-video-card__facebook-link">
                    Watch on Facebook
                  </a>
                </div>
              ) : (
                <iframe
                  src={video.embedUrl}
                  title={video.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
